export default "__VITE_ASSET__BZM4eFHZ__"